import React from 'react';
import type { HighlightHelpNoteData } from '../../types';
import { parseEm } from './parseEm';
import '../../styles/highlight/HighlightHelpNote.css';

interface HighlightHelpNoteProps {
  data: HighlightHelpNoteData;
}

const HighlightHelpNote: React.FC<HighlightHelpNoteProps> = ({ data }) => (
  <div className="psl-hl-help">
    <div className="psl-hl-help__lbl">{data.label}</div>
    <h3 className="psl-hl-help__title">
      {data.title.pre}
      {data.title.accent && <em>{data.title.accent}</em>}
      {data.title.post}
    </h3>
    {data.rows.map((row, i) => (
      <div key={i} className="psl-hl-help__row">
        <span className="psl-hl-help__k">{row.k}</span>
        <span className="psl-hl-help__v">{parseEm(row.v)}</span>
      </div>
    ))}
    {data.handTag && (
      <span className="psl-hl-help__hand">{data.handTag}</span>
    )}
  </div>
);

export default HighlightHelpNote;
